import AppHeader from "@/components/AppHeader";

export default {
  name: "master-phrase",
  components: {
    AppHeader
  },
  created() {
    this.getCompany();
    this.getPhrase();
  },
  data() {
    return {
      companies: "",
      phrases: [],
      selectedCompany: localStorage.company_id,
      getCompanisEnd: false,
      getPhrasesEnd: false
    };
  },
  computed: {
    authorityCheckNotUseCompany() {
      if (
        localStorage.user_authority == 3 ||
        localStorage.user_authority == 4
      ) {
        // 総務部でログイン
        return true;
      }
      return false;
    }
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompanisEnd = true;
    },
    async getPhrase() {
      this.getPhrasesEnd = false;
      let data = {
        company_id: this.selectedCompany
      };
      let res = await this.$store
        .dispatch("GET_PHRASE", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.phrases = res.phrases;
      this.getPhrasesEnd = true;
    },
    goPhraseEdit(phraseId) {
      this.$router.push({ path: `/master_phrase/${phraseId}/edit` });
    },
    deleteModal(phraseId) {
      this.deletePhraseId = phraseId;
      this.$bvModal.show("modal-delete");
    },
    async deletePhrase() {
      let res = await this.$store
        .dispatch("DELETE_PHRASE", {
          id: this.deletePhraseId,
          data: {}
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (!res.error) {
        this.getPhrase();
      }
      this.$bvModal.hide("modal-delete");
    },
    content(word) {
      return word
        ? word
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/"/g, "&#39;")
            .replace(/\r?\n/g, "<br>")
        : "";
    }
  }
};
